export function redirectToAuthService() {
  const urlParams = new URLSearchParams({
    redirect_uri: window.location.origin,
    response_type: 'code',
    client_id: window.SSO_CLIENT_ID,
    state: window.SSO_STATE,
    code_challenge: window.SSO_CODE_CHALLENGE,
    code_challenge_method: 'plain',
  });

  window.location.assign(
    `${window.SSO_ENDPOINT}/as/authorization.oauth2?${urlParams}`
  );
}
